export default __webpack_public_path__ + "static/media/beyowi.4ccbab15.png";